import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon } from '@hotjar/hotsauce';
import { SessionEndedButton } from './SessionEndedButton';

export const NextButton = ({ onClick, disabled }) => {
  const { t } = useTranslation();
  return (
    <SessionEndedButton
      tooltip={t('common:player.next-button')}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon icon="next" size="m" />
    </SessionEndedButton>
  );
};

NextButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NextButton.defaultProps = {
  disabled: false,
};
